// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bb-big-card{display:flex;flex-direction:column;cursor:pointer;border:2px solid transparent}.bb-big-card .bb-big-card__picture{position:relative;height:auto}.bb-big-card .bb-big-card__picture img{max-height:130px}.bb-big-card--mobile .bb-big-card__picture img{max-height:150px}.bb-big-card--selected{border:2px solid #fff!important}.bb-big-card__picture{display:flex;justify-content:center;align-items:center;flex-grow:1}.bb-big-card__metas{text-align:left;height:120px}", ""]);
// Exports
module.exports = exports;
